import {
  EmptyState,
  FiFileText,
  FormProvider,
  Stack,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { MultipleEquityInfoDocument } from './MultipleEquityInfoDocument';
import { useEquityInfo } from './hooks/useEquityInfoForm';
import {
  CompanyEquityInformationSerializer,
  ExplorerAccessibleSectionSerializer,
} from '@bcba/serializers';
import { RestrictedSection } from '../RestrictedSection';

interface Props {
  equityInformation: ExplorerAccessibleSectionSerializer<CompanyEquityInformationSerializer>;
}
export const ReadOnlyEquityInfoSection = ({ equityInformation }: Props) => {
  const { t } = useTranslation();
  const { hasAccess, data } = equityInformation;

  const { formMethods } = useEquityInfo(data);

  if (!hasAccess) return <RestrictedSection />;

  if (!data)
    return (
      <EmptyState
        title={t('sharedDigitalDossier.equityInformation.emptyState.title')}
        description={t(
          'sharedDigitalDossier.equityInformation.emptyState.description',
        )}
        size="md"
        icon={FiFileText}
      />
    );

  return (
    <form>
      <FormProvider {...formMethods}>
        <Stack gap={8}>
          <MultipleEquityInfoDocument
            name="balanceDocuments"
            label={t('common.equityInformation.balance.title')}
          />
          <MultipleEquityInfoDocument
            name="additionalDocuments"
            label={t('common.equityInformation.additionalDocument.title')}
          />
        </Stack>
      </FormProvider>
    </form>
  );
};

export default ReadOnlyEquityInfoSection;
